import { render, staticRenderFns } from "./CreateEditAccessLink.vue?vue&type=template&id=6a72765e&scoped=true"
import script from "./CreateEditAccessLink.vue?vue&type=script&lang=js"
export * from "./CreateEditAccessLink.vue?vue&type=script&lang=js"
import style0 from "./CreateEditAccessLink.vue?vue&type=style&index=0&id=6a72765e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a72765e",
  null
  
)

export default component.exports